import { makeAutoObservable } from "mobx";
import construct from "../utils/construct";

// eslint-disable-next-line
let _rootStore;

const NOTICE_TTL_MS = 10 * 60 * 1000;

/**
 * Notifica ediciones ajenas (recibidas por SSE de otro usuario) sobre entidades,
 * para que los formularios abiertos puedan avisar de posibles sobrescrituras.
 * Solo vive en memoria (no se persiste).
 */

/** @type {Record<string, { type: string, id: string, action: string, at: number }>} */
const defaultProperties = {
	notices: {},
};

export default class EditedEntityStore {
	constructor(rootStore) {
		construct(this, defaultProperties);
		_rootStore = rootStore;

		makeAutoObservable(this);
	}

	reset() {
		construct(this, defaultProperties);
	}

	/**
	 * @param {string} type
	 * @param {string} id
	 */
	noticeKey(type, id) {
		return `${type}:${id}`;
	}

	/**
	 * @param {Object} params
	 * @param {string} params.type - Tipo de entidad (p. ej. "economosMovement")
	 * @param {string} params.id
	 * @param {"updated" | "deleted"} params.action
	 */
	notifyForeignEdit({ type, id, action }) {
		this.pruneExpiredNotices();

		this.notices[this.noticeKey(type, id)] = { type, id, action, at: Date.now() };
	}

	/**
	 * @param {string} type
	 * @param {string} id
	 * @returns {{ type: string, id: string, action: string, at: number } | null}
	 */
	getNotice(type, id) {
		return this.notices[this.noticeKey(type, id)] ?? null;
	}

	/**
	 * @param {string} type
	 * @param {string} id
	 */
	clearNotice(type, id) {
		delete this.notices[this.noticeKey(type, id)];
	}

	pruneExpiredNotices() {
		const now = Date.now();

		for (const key of Object.keys(this.notices)) {
			if (now - this.notices[key].at > NOTICE_TTL_MS) {
				delete this.notices[key];
			}
		}
	}
}
